// @flow
import styled from 'styled-components';

export const Inner = styled.div`
  ${({ bottomMargin = false }) => bottomMargin && `margin-bottom: 64px;`}
`;
